import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';

const resolveIconStyling = (variant, theme) => {
  switch (variant) {
    case 'error':
      return css`
        background-color: ${theme.error.background};
      `;
    case 'warning':
      return css`
        background-color: ${theme.warning.background};
      `;
    case 'success':
      return css`
        background-color: ${theme.success.background};
      `;
    default:
      return css`
        background-color: ${theme.info.background};
      `;
  }
};

const InlineFeedbackMessageContent = styled.div`
  ${Tokens.TYPOGRAPHY.BODY}
  padding: ${Tokens.SPACING.SPACING_8} ${Tokens.SPACING.SPACING_0};
  flex-grow: 1;
  color: ${props => props.$theme[props.$variant].text};
  ${props =>
    props.$rtl
      ? css`
          margin-left: ${Tokens.SPACING.SPACING_12};
        `
      : css`
          margin-right: ${Tokens.SPACING.SPACING_12};
        `}
        ${props => (props.$closeButton || props.$hyperlink) && css`
          margin: auto;
        `};
`;

const InlineFeedbackMessageIcon = styled.div`
  padding: ${Tokens.SPACING.SPACING_8} ${Tokens.SPACING.SPACING_12} ${Tokens.SPACING.SPACING_8} ${Tokens.SPACING.SPACING_8};

  ${props =>
    props.$rtl &&
    css`
      padding: ${Tokens.SPACING.SPACING_8} ${Tokens.SPACING.SPACING_8} ${Tokens.SPACING.SPACING_8}
        ${Tokens.SPACING.SPACING_12};
    `};

  display: flex;
  align-self: flex-start;
`;

const InlineFeedbackMessageHyperlink = styled.div`
  padding: ${Tokens.SPACING.SPACING_8} 0;
  align-self: flex-start;
  a {
    color: ${props => props.$theme.hyperlink};
  }
  ${props =>
    props.$rtl
      ? css`
          padding-left: ${Tokens.SPACING.SPACING_12};
          padding-right: ${Tokens.SPACING.SPACING_16};
        `
      : css`
          padding-left: ${Tokens.SPACING.SPACING_16};
          padding-right: ${Tokens.SPACING.SPACING_12};
        `}
`;
const InlineFeedbackMessageProgressIndicator = styled.div`
  margin: ${Tokens.SPACING.SPACING_8};
  max-height: 1.5rem;
  max-width: 1.5rem;
  display: flex;
  align-self: flex-start;
  ${props =>
    props.$rtl
      ? css`
          margin-right: ${Tokens.SPACING.SPACING_16};
        `
      : css`
          margin-left: ${Tokens.SPACING.SPACING_16};
        `}
`;

const InlineFeedbackMessageCloseButton = styled.div`
  padding: ${Tokens.SPACING.SPACING_4};
  display: flex;
  align-self: flex-start;
  ${props =>
    props.$rtl
      ? css`
          padding-right: ${Tokens.SPACING.SPACING_16};
        `
      : css`
          padding-left: ${Tokens.SPACING.SPACING_16};
        `}
`;

const InlineFeedbackMessage = styled.div`
  ${DEEP_BORDER_BOX}
  ${props => resolveIconStyling(props.$variant, props.$theme)}
  ${props =>
    props.$rtl &&
    css`
      direction: rtl;
    `}
  border-radius: ${Tokens.RADIUS.RADIUS_2};
  display: flex;
  align-items: center;
  ${props => props.$elevationStyle}
`;

const InlineFeedbackMessagesContainer = styled.div`
  ${DEEP_BORDER_BOX}
  overflow: auto;
  ${InlineFeedbackMessage} {
    &:not(:first-child) {
      margin-top: 0.625rem;
    }
  }
  ${props =>
    props.$overlay &&
    css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      padding: 0.375rem;
      z-index: 1;
    `};
`;

const InlineFeedbackMessageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: ${props => props.theme.overlay};
  width: 100%;
  height: 100%;
`;

const styles = {
  InlineFeedbackMessageContent,
  InlineFeedbackMessageIcon,
  InlineFeedbackMessageCloseButton,
  InlineFeedbackMessageHyperlink,
  InlineFeedbackMessageProgressIndicator,
  InlineFeedbackMessage,
  InlineFeedbackMessagesContainer,
  InlineFeedbackMessageOverlay
};

export default styles;
